export const getCompletePhone = ({ value }) => (value ? '+'.concat(value) : '');

export const getCorrenctName = ({ quickCode, value }) =>
  value?.toLowerCase().includes(quickCode.toLowerCase()) ? '' : value;

export const getCorrectValue = ({ value }) => (value ? value : '');
